<div class="agent-wrap" [@fadeInOut]>

  <!-- ── Header ── -->
  <div class="agent-header">
    <div class="agent-header-left">
      <div class="agent-logo-mark">AI</div>
      <div class="agent-header-info">
        <div class="agent-name">{{ agentName }}</div>
        <div class="agent-model">{{ modelName }}</div>
      </div>
      <span class="pii-pill" title="Zero PII is sent to OpenAI. All names, emails and addresses are replaced with opaque tokens before any model call.">🔒 Zero PII</span>
    </div>
    <div class="agent-header-right">
      <button type="button" class="btn-ghost" (click)="toggleCostMeter()">
        {{ showCostMeter ? 'Hide usage' : 'Usage' }}
      </button>
      <button type="button" class="btn-ghost" (click)="reset()">New chat</button>
    </div>
  </div>

  <!-- ── Disclaimer ── -->
  <div class="agent-notice">
    <span class="notice-icon">ℹ</span>
    AI assistant — verify answers before acting on them.
  </div>

  <!-- ── Message feed ── -->
  <div class="message-feed" #messageList>

    <div *ngFor="let t of turns" class="message-row">

      <!-- User message -->
      <div *ngIf="t.role === 'user'" class="user-msg">
        <div class="user-msg-text">{{ t.text }}</div>
        <div class="user-msg-label">You</div>
      </div>

      <!-- Assistant turn -->
      <div *ngIf="t.role === 'assistant'" class="assistant-turn">

        <!-- Tool log entries -->
        <div *ngIf="t.tools && t.tools.length" class="tool-log">
          <div *ngFor="let tool of t.tools; let last = last" class="log-entry">
            <div class="log-left">
              <div class="log-icon" [ngClass]="tool.success ? 'ok' : 'neutral'">
                {{ tool.success ? '✓' : '·' }}
              </div>
              <div class="log-line" *ngIf="!last || !t.pending && t.text"></div>
            </div>
            <div class="log-body">
              <div class="log-meta">
                <span class="log-tool-name">{{ tool.tool }}</span>
                <span class="log-time">{{ tool.latencyMs }} ms</span>
                <span class="log-pill" [ngClass]="tool.success ? 'ok' : 'neutral'">
                  {{ tool.success ? 'Success' : 'No data' }}
                </span>
              </div>
              <details class="log-detail-wrap">
                <summary>View details</summary>
                <div class="log-detail">
                  <div class="log-detail-row">
                    <span class="log-detail-key">Arguments</span>
                    <span class="log-detail-val">{{ tool.input }}</span>
                  </div>
                  <div class="log-detail-row">
                    <span class="log-detail-key">Result preview</span>
                    <span class="log-detail-val">{{ tool.outputPreview }}</span>
                  </div>
                </div>
              </details>
            </div>
          </div>
        </div>

        <!-- Thinking indicator -->
        <div *ngIf="t.pending" class="thinking-row">
          <div class="log-left">
            <div class="log-icon ai">AI</div>
          </div>
          <div class="thinking-dots">
            <span class="dot"></span><span class="dot"></span><span class="dot"></span>
            <span class="thinking-label">Thinking…</span>
          </div>
        </div>

        <!-- Response text -->
        <div *ngIf="!t.pending && t.text" class="response-row">
          <div class="log-left">
            <div class="log-icon ai">AI</div>
          </div>
          <div class="response-body">
            <div class="response-meta">
              <span class="log-tool-name">{{ agentName }}</span>
            </div>
            <div class="response-text" [innerText]="t.text"></div>
            <div *ngIf="t.error" class="msg-error">⚠ {{ t.error }}</div>
            <div *ngIf="showCostMeter && (t.inputTokens || t.outputTokens)" class="cost-meter">
              in: {{ t.inputTokens }} ({{ t.cachedInputTokens || 0 }} cached) · out: {{ t.outputTokens }}
            </div>
          </div>
        </div>

        <div *ngIf="!t.pending && !t.text && t.error" class="msg-error" style="margin-left:34px">⚠ {{ t.error }}</div>

      </div>

      <!-- System message -->
      <div *ngIf="t.role === 'system'" class="system-msg">
        {{ t.text }}
        <div *ngIf="t.error" class="msg-error">⚠ {{ t.error }}</div>
      </div>

    </div>
  </div>

  <!-- ── Composer ── -->
  <form class="composer" (ngSubmit)="send()">
    <textarea
      class="composer-input"
      [(ngModel)]="draft"
      name="draft"
      placeholder="Ask anything — e.g. 'Which ICDs have been stuck in Step 2 for more than 7 days?'"
      rows="2"
      [disabled]="busy"
      (keydown.enter)="$event.preventDefault(); send()"
    ></textarea>
    <button type="submit" class="composer-send" [disabled]="busy || !draft?.trim()">Send</button>
  </form>

</div>
